module.exports = __webpack_public_path__ + "static/media/cmuBuilding.17cf5c6e.jpg";